export function CurrentSeason() {
    const currentDate = new Date()
    currentDate.setMonth(currentDate.getMonth() + 4)
    return currentDate.getFullYear()
}
